import { IPharmacyInfo } from "@/Common/Api/Pharmacy/Dto/Responses/IPharmacyInfo";
import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { FileType } from "@/Common/Models/FileType";
import { PatientRefIntervenorWithDetailsModel } from "@/Common/Models/Patient/PatientRefIntervenorWithDetailsModel";
import { FaxAndSignatureLabRequestSelection } from "@/ExportableFile/Components/FaxAndSignatureLabRequestSelection";
import { PharmacyFaxSelection } from "@/ExportableFile/Components/PharmacyFaxSelection";
import { ExportableFile } from "@/ExportableFile/Models/ExportableFile";
import { FileTypePrescription } from "@/ExportableFile/Models/FileTypes/FileTypePrescription";
import { ClinicianFaxSender } from "./ClinicianFaxSender";
import { FaxSignPrintExportableFileComponentState, FaxSignPrintExportableFileDefaultContext } from "./FaxSignPrintExportableFileComponent";

export interface FaxSenderSelectorProps {
    defaultContext: FaxSignPrintExportableFileDefaultContext;
    customPharmacy?: IPharmacyInfo;
    exportableFile?: ExportableFile;
    state: FaxSignPrintExportableFileComponentState;
    mutateState: (mutation: (state: FaxSignPrintExportableFileComponentState) => void, then?: () => void) => void;
    showSpinningWheel: boolean;
    useLabsSearch: boolean; // Temporary prop to allow overriding which table to search for. This will be removed when ContactDirectory project is merged.
    patientContactId: string;
}

export class FaxSenderSelector extends BaseReactComponent<FaxSenderSelectorProps> {
    public render(): JSX.Element {
        switch (this.props.exportableFile?.fileType) {
            case FileType.Prescription:
                return (
                    <PharmacyFaxSelection
                        defaultContent={this.props.defaultContext as IPharmacyInfo}
                        exportableFile={this.props.exportableFile as FileTypePrescription}
                        onDataChange={(isValid, description, faxNumber, exportableFile, phoneNumber) => this.props.mutateState(s => {
                            s.exportableFile = exportableFile;
                            s.faxDescription = description;
                            s.faxNumber = faxNumber;
                            s.isValidFax = isValid;
                            s.phoneNumber = phoneNumber;
                        })}
                        isSending={this.props.showSpinningWheel}
                        customPharmacy={this.props.customPharmacy}
                        patientContactId={this.props.patientContactId}
                    />
                );
            case FileType.TemporaryFileForClinicians:
            case FileType.ENCOUNTER:
            case FileType.CONSULTATIONREQUEST:
                return (
                    <ClinicianFaxSender
                        defaultContent={this.props.defaultContext as PatientRefIntervenorWithDetailsModel[]}
                        exportableFile={this.props.exportableFile}
                        onDataChange={(isValid, description, faxNumber, exportableFile, phoneNumber) => this.props.mutateState(s => {
                            s.exportableFile = exportableFile;
                            s.faxDescription = description;
                            s.faxNumber = faxNumber;
                            s.isValidFax = isValid;
                            s.phoneNumber = phoneNumber;
                        })}
                        isSending={this.props.showSpinningWheel}
                        useLabsSearch={this.props.useLabsSearch}
                    />
                );
            default:
                return (
                    <FaxAndSignatureLabRequestSelection
                        exportableFile={this.props.exportableFile}
                        shouldFocusRecipientOnMount={!sessionStore.signOnPrintAccess}
                        onDataChange={(isValid, name, fax, exportableFile, phoneNumber) =>
                            this.props.mutateState(s => {
                                s.isValidFax = isValid && !IsNullOrWhiteSpace(name);
                                s.faxDescription = name;
                                s.faxNumber = fax;
                                s.exportableFile = exportableFile;
                                s.phoneNumber = phoneNumber;
                            })
                        }
                    />
                );
        }
    }
}
